import React from 'react';
import SurfaceCard from './SurfaceCard';
import {BoxProps, Heading, Text, VStack} from 'components/ui/chakra';

interface StatCardProps extends BoxProps {
	label: React.ReactNode;
	helperText?: React.ReactNode;
	value: React.ReactNode;
}

const StatCard = ({label, helperText, value, ...rest}: StatCardProps) => (
	<SurfaceCard p={5} {...rest}>
		<VStack align='flex-start' gap={2}>
			<Text
				color='subtleText'
				fontSize='0.74rem'
				fontWeight='700'
				letterSpacing='0.1em'
				textTransform='uppercase'
			>
				{label}
			</Text>
			<Heading as='div' fontSize={{base: '2xl', md: '3xl'}}>
				{value}
			</Heading>
			{helperText && (
				<Text color='subtleText' fontSize='sm'>
					{helperText}
				</Text>
			)}
		</VStack>
	</SurfaceCard>
);

export default StatCard;
